import { SetStateAction, useState } from 'react'

import { CargoTypes } from '../../../../types/enums'
import { TypesObject } from '../../../../types/interfaces'

export const useCargoSelector = (
  setTopData: React.Dispatch<SetStateAction<TypesObject>>,
  topData: TypesObject,
) => {
  const [type, setType] = useState<CargoTypes[]>(topData ? topData.cargo_types : [])

  const toggleType = (value: number) => {
    setType((prev) => {
      if (prev.includes(value)) {
        setTopData((prev) => ({
          ...prev,
          cargo_types: [...type.filter((el) => el !== value)],
        }))
        return prev.filter((el) => el !== value)
      }
      setTopData((prev) => ({
        ...prev,
        cargo_types: [...[...type, value]],
      }))
      return [...prev, value]
    })
    //edit
  }

  return {
    toggleType,
    type,
  }
}
